<template>
  <b-container id="header-container" fluid>
    <b-row class="justify-content-center">
      <b-col md="10">
        <!--
        <b-row align-h="between">
          <b-col md="6">
            <a href="/">
              <img alt="gravity logo" src="../../assets/logo.png" />
            </a>
          </b-col>
          <b-col md="6" class="join-button">
            <a
              href="https://zoom.us/webinar/register/WN_amII22BgS2C0_NlExIbqFw"
              target="_blank"
            >
              <b-button class="button-white-transparen"
                >Join Live Shows</b-button
              >
            </a>
          </b-col>
        </b-row>
        -->
        <b-row align-h="start" class="text-content">
          <b-col>
            <h1 class="text-white title text-left">Crush Your Quota</h1>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col class="mt-2">
            <h2 class="text-white sub-title text-left">What your best sales rep will take away from the show</h2>
          </b-col>
        </b-row>
        <!--
        <b-row align-h="start">
          <b-col class="mt-2">
            <h2 class="text-white sub-title text-left">Supercharge sales with a data advantage</h2>
          </b-col>
        </b-row>
        -->
        <!--
        <b-row align-h="start">
          <b-col class="mt-1">
            <h3 class="text-white third-sub-title text-left">Join our 15 minute daily briefs from Top Performers</h3>
          </b-col>
        </b-row>

        <b-row align-h="start">
          <b-col class="mt-1" md="6" sm="12">
            <h4 class="text-white text-left">Participates will leave with a great piece of content highlighting their current sales strategy and framing them as a champion. The show will provide them a free targeting strategy session with a top data expert and a sales strategy session with a top sales coach. They’ll walk away with a sales plan to execute and 100-500 highly targeted prospects based on their exact criteria. A month later our editors will produce another short piece of content for them to share describing the effect of the campaign.  </h4>
          </b-col>
        </b-row>


        <b-row align-h="start">
          <b-col
            cols="12"
            md="3"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
            >
              <b-button class="calendar-button">
                Join the community
              </b-button>
            </a>

          </b-col>
          <b-col
            cols="12"
            md="3"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://www.launchgravity.com/masters-of-marketing"
            >
              <b-button class="calendar-button">
                Watch our Marketing Show
              </b-button>
            </a>

          </b-col>
          <b-col
            cols="12"
            md="7"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://jodykung.typeform.com/to/xx2Q8KJf"
            >
              <b-button class="calendar-button">
                Apply to Speak
              </b-button>
            </a>
          </b-col>
        </b-row>

        -->

        <!--
        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-2 justify-content-center justify-content-md-start"
          >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
            >
              <b-button class="calendar-button">
                Watch on Facebook Live
              </b-button>
            </a>
          </b-col>
        </b-row>
        -->
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/header.sass
</style>

<script>
export default {
  name: 'Header',
}
</script>
